import PropTypes from 'prop-types';

/**
 * Badge Component
 *
 * Small status badge for displaying labels with color variants.
 * Based on Preline UI badge patterns.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Badge content
 * @param {'primary'|'secondary'|'success'|'danger'|'warning'|'info'|'tag'|'status-active'|'status-inactive'|'status-pending'} props.variant - Badge color variant
 * @param {string} props.className - Additional CSS classes
 */
export function Badge({ children, variant = 'primary', className = '' }) {
  // Inline opacity pattern (follows shadcn/ui + Tailwind philosophy)
  // Pattern: bg-{semantic}/10 text-{semantic} border-{semantic}/20
  const variantClasses = {
    primary: 'bg-brand/10 text-brand border border-brand',
    secondary: 'bg-brand/4 text-brand/50 border border-transparent',
    success: 'bg-success/10 text-success border border-success/20',
    danger: 'bg-error/10 text-error border border-error/20',
    warning: 'bg-warning/10 text-warning border border-warning/20',
    info: 'bg-tertiary/20 text-tertiary-dark border border-tertiary/30',
    tag: 'bg-brand/3 text-brand border border-transparent',
    'status-active': 'bg-success/10 text-success border border-success/20',
    'status-pending': 'bg-warning/10 text-warning border border-warning/20',
    'status-inactive': 'bg-disabled-bg text-muted border border-transparent',
  };

  return (
    <span
      className={`
        inline-flex items-center gap-x-1 py-1 px-2 rounded-full text-xs font-medium border
        ${variantClasses[variant]}
        ${className}
      `}
    >
      {children}
    </span>
  );
}

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'tag', 'status-active', 'status-inactive', 'status-pending']),
  className: PropTypes.string,
};
